var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10487_18869)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10487_18869",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H16V16H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10487_18869)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.999 8.00001C15.999 9.05065 15.7921 10.091 15.39 11.0617C14.988 12.0323 14.3987 12.9143 13.6558 13.6572C12.9128 14.4001 12.0309 14.9894 11.0602 15.3915C10.0895 15.7936 9.04919 16.0005 7.99855 16.0005C6.94791 16.0005 5.90755 15.7936 4.93689 15.3915C3.96622 14.9894 3.08425 14.4001 2.34134 13.6572C1.59842 12.9143 1.00911 12.0323 0.607049 11.0617C0.204986 10.091 -0.00195314 9.05065 -0.00195312 8.00001C-0.00195309 5.87815 0.840954 3.84319 2.34134 2.3428C3.84172 0.842419 5.87668 -0.000488281 7.99855 -0.000488281C10.1204 -0.000488281 12.1554 0.842419 13.6558 2.3428C15.1561 3.84319 15.999 5.87815 15.999 8.00001Z",
    fill: "url(#paint0_linear_10487_18869)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.64113 10.888C5.48313 12.733 6.36813 14 7.99813 14C9.62813 14 10.5131 12.733 10.3551 10.888C10.1981 9.042 9.24013 8 7.99813 8C6.75613 8 5.79813 9.042 5.64113 10.888Z",
    fill: "url(#paint1_linear_10487_18869)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 5.5C3.5 4.672 4.059 4 4.75 4C5.441 4 6 4.672 6 5.5C6 6.329 5.441 7 4.75 7C4.059 7 3.5 6.329 3.5 5.5ZM10 5.5C10 4.672 10.56 4 11.25 4C11.941 4 12.5 4.672 12.5 5.5C12.5 6.329 11.941 7 11.25 7C10.56 7 10 6.329 10 5.5Z",
    fill: "url(#paint2_linear_10487_18869)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_10487_18869)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.5 5.5C3.5 4.672 4.059 4 4.75 4C5.441 4 6 4.672 6 5.5C6 6.329 5.441 7 4.75 7C4.059 7 3.5 6.329 3.5 5.5ZM10 5.5C10 4.672 10.56 4 11.25 4C11.941 4 12.5 4.672 12.5 5.5C12.5 6.329 11.941 7 11.25 7C10.56 7 10 6.329 10 5.5Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.4795 4.56717C4.6655 4.60917 4.7695 4.81917 4.7115 5.03717C4.6545 5.25417 4.4575 5.39717 4.2715 5.35417C4.0855 5.31217 3.9815 5.10217 4.0395 4.88417C4.0965 4.66817 4.2935 4.52417 4.4795 4.56717ZM11.1385 4.63017C11.3435 4.67717 11.4595 4.91017 11.3965 5.15017C11.3325 5.39317 11.1145 5.55017 10.9065 5.50417C10.7015 5.45817 10.5845 5.22417 10.6485 4.98417C10.7115 4.74117 10.9305 4.58417 11.1385 4.63017Z",
    fill: "#4E506A"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_10487_18869)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0663 1.69584C11.1183 1.69084 11.1703 1.68884 11.2233 1.68884C11.7103 1.68884 12.2133 1.89284 12.5953 2.25084C12.6378 2.29144 12.6699 2.34163 12.6891 2.39721C12.7082 2.45279 12.7137 2.51215 12.7052 2.57032C12.6967 2.62848 12.6744 2.68376 12.6401 2.73152C12.6058 2.77928 12.5606 2.81814 12.5083 2.84484C12.4453 2.87538 12.3745 2.886 12.3054 2.87528C12.2362 2.86456 12.172 2.83301 12.1213 2.78484C11.8463 2.52484 11.4653 2.38484 11.1293 2.41484C11.0126 2.42368 10.8993 2.45799 10.7974 2.51535C10.6955 2.57271 10.6073 2.65173 10.5393 2.74684C10.5119 2.7839 10.4774 2.81511 10.4377 2.83865C10.3981 2.86219 10.3542 2.87758 10.3086 2.88391C10.2629 2.89024 10.2165 2.8874 10.1719 2.87554C10.1274 2.86368 10.0857 2.84304 10.0493 2.81484C9.97439 2.75564 9.92545 2.66968 9.91276 2.57509C9.90007 2.48049 9.92463 2.38467 9.98126 2.30784C10.1072 2.13358 10.2694 1.98865 10.4567 1.88301C10.644 1.77737 10.852 1.71352 11.0663 1.69584ZM3.40126 2.25084C3.77226 1.89784 4.26126 1.69784 4.77326 1.68884C5.01496 1.68351 5.25434 1.73708 5.47072 1.84492C5.6871 1.95276 5.87399 2.11164 6.01526 2.30784C6.07186 2.38451 6.0966 2.48012 6.08429 2.57462C6.07199 2.66913 6.0236 2.75521 5.94926 2.81484C5.9127 2.84322 5.87084 2.86401 5.82613 2.87597C5.78142 2.88793 5.73477 2.89083 5.68893 2.8845C5.64308 2.87816 5.59897 2.86272 5.55918 2.83908C5.5194 2.81543 5.48474 2.78407 5.45726 2.74684C5.38906 2.65192 5.3009 2.57309 5.19897 2.5159C5.09703 2.45872 4.98381 2.42456 4.86726 2.41584C4.53226 2.38484 4.15026 2.52584 3.87526 2.78484C3.84157 2.81673 3.80178 2.84148 3.75828 2.85759C3.71478 2.87371 3.66847 2.88086 3.62214 2.87862C3.5758 2.87638 3.5304 2.86479 3.48866 2.84455C3.44692 2.82431 3.40971 2.79583 3.37926 2.76084C3.31625 2.68949 3.28335 2.5965 3.28745 2.5014C3.29155 2.40631 3.33234 2.3165 3.40126 2.25084Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.0663 1.69584C11.1183 1.69084 11.1703 1.68884 11.2233 1.68884C11.7103 1.68884 12.2133 1.89284 12.5953 2.25084C12.6378 2.29144 12.6699 2.34163 12.6891 2.39721C12.7082 2.45279 12.7137 2.51215 12.7052 2.57032C12.6967 2.62848 12.6744 2.68376 12.6401 2.73152C12.6058 2.77928 12.5606 2.81814 12.5083 2.84484C12.4453 2.87538 12.3745 2.886 12.3054 2.87528C12.2362 2.86456 12.172 2.83301 12.1213 2.78484C11.8463 2.52484 11.4653 2.38484 11.1293 2.41484C11.0126 2.42368 10.8993 2.45799 10.7974 2.51535C10.6955 2.57271 10.6073 2.65173 10.5393 2.74684C10.5119 2.7839 10.4774 2.81511 10.4377 2.83865C10.3981 2.86219 10.3542 2.87758 10.3086 2.88391C10.2629 2.89024 10.2165 2.8874 10.1719 2.87554C10.1274 2.86368 10.0857 2.84304 10.0493 2.81484C9.97439 2.75564 9.92545 2.66968 9.91276 2.57509C9.90007 2.48049 9.92463 2.38467 9.98126 2.30784C10.1072 2.13358 10.2694 1.98865 10.4567 1.88301C10.644 1.77737 10.852 1.71352 11.0663 1.69584ZM3.40126 2.25084C3.77226 1.89784 4.26126 1.69784 4.77326 1.68884C5.01496 1.68351 5.25434 1.73708 5.47072 1.84492C5.6871 1.95276 5.87399 2.11164 6.01526 2.30784C6.07186 2.38451 6.0966 2.48012 6.08429 2.57462C6.07199 2.66913 6.0236 2.75521 5.94926 2.81484C5.9127 2.84322 5.87084 2.86401 5.82613 2.87597C5.78142 2.88793 5.73477 2.89083 5.68893 2.8845C5.64308 2.87816 5.59897 2.86272 5.55918 2.83908C5.5194 2.81543 5.48474 2.78407 5.45726 2.74684C5.38906 2.65192 5.3009 2.57309 5.19897 2.5159C5.09703 2.45872 4.98381 2.42456 4.86726 2.41584C4.53226 2.38484 4.15026 2.52584 3.87526 2.78484C3.84157 2.81673 3.80178 2.84148 3.75828 2.85759C3.71478 2.87371 3.66847 2.88086 3.62214 2.87862C3.5758 2.87638 3.5304 2.86479 3.48866 2.84455C3.44692 2.82431 3.40971 2.79583 3.37926 2.76084C3.31625 2.68949 3.28335 2.5965 3.28745 2.5014C3.29155 2.40631 3.33234 2.3165 3.40126 2.25084Z",
    fill: "url(#paint3_linear_10487_18869)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_10487_18869",
    x: 2.5,
    y: 3,
    width: 11,
    height: 5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0980392 0 0 0 0 0.101961 0 0 0 0 0.2 0 0 0 0.819684 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10487_18869"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10487_18869",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_10487_18869",
    x: 0.287109,
    y: -0.311523,
    width: 15.4219,
    height: 7.19922,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.803922 0 0 0 0 0.388235 0 0 0 0 0.00392157 0 0 0 0.145679 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10487_18869"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10487_18869",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10487_18869",
    x1: 7.99905,
    y1: 1.64001,
    x2: 7.99905,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEEA70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F69B30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10487_18869",
    x1: 7.99813,
    y1: 8,
    x2: 7.99813,
    y2: 14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#472315"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8B3A0E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10487_18869",
    x1: 8,
    y1: 4,
    x2: 8,
    y2: 7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#191A33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.872,
    stopColor: "#3B426A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_10487_18869",
    x1: 7.99826,
    y1: 1.68784,
    x2: 7.99826,
    y2: 2.88784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E78E0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB6000"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10487_18869"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWow);
export default __webpack_public_path__ + "static/media/wow.bdb9e37c45500886eb01f8b1e0f0f033.svg";
export { ForwardRef as ReactComponent };